import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportComponentDefinitionModel} from '../reportComponentDefinition.model';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {
    FormDefinitionFormConverter
} from '../../../../../form/definition/form/api/entity/converter/formDefinitionForm.converter';
import {ReportTemplateConverter} from '../../../../report-template/api/entity/converter/reportTemplate.converter';

@Injectable()
export class ReportComponentDefinitionConverter extends HttpModelConverter<ReportComponentDefinitionModel> {

    public constructor(private templateConverter: ReportTemplateConverter,
                       private formDefinitionFormConverter: FormDefinitionFormConverter,
                       private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): ReportComponentDefinitionModel {
        return new ReportComponentDefinitionModel();
    }

    protected enrichObject(result: ReportComponentDefinitionModel, src: ReportComponentDefinitionModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.template = this.templateConverter.convert(src.template);
        result.formDefinition = this.formDefinitionFormConverter.convert(src.formDefinition);
    }


}
